import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './Pages/Login';
import ForgotPassord from './Pages/ForgotPassword';
import { ChooseIdentity, ModeratorRegister } from './Pages/Register';
import HomePage from './Pages/HomePage';
import BasicInfo from './Pages/BasicInfo';
import TestRecord from './Pages/TestRecord';
import AddPatientData from './Components/CRUDPage/AddPatientData';
import QuestionEncounter from './Components/Homepage/QuestionsEncounter';
import { FilterContextsProvider } from './Variables/FilterContexts';

// import AddImageFromPDF from './Components/CRUDPage/AddImageFromPDF';
// import AddPDF from './Components/CRUDPage/AddPDF';
// import AddDrugRecord from './Components/CRUDPage/AddDrugRecord';
// import AddExamineRecord from './Components/CRUDPage/AddExamineRecord';
// import RecordChart from './Components/RecordPage/RecordChart';
// import ListAllDrug from './Components/RecordPage/ListAllDrug';

function App() {
    return (
        <FilterContextsProvider>
            <BrowserRouter basename="/glaucoma_chart/frontend">
            <Routes>
                <Route path="/">
                    <Route index element={<Login/>}/>
                    <Route path="forgot_password" element={<ForgotPassord/>}></Route>
                    <Route path="register">
                        <Route index element={<ChooseIdentity/>}/>
                        <Route path="moderator_register" element={<ModeratorRegister/>}></Route>
                    </Route>
                    <Route path="home" element={<HomePage/>}>
                        <Route path="basic_info" element={<BasicInfo/>}/>
                        <Route path="test_record" element={<TestRecord/>}/>
                        <Route path="add_record" element={<TestRecord WhichPage={"add_record"}/>}/>
                        <Route path="new_patient" element={<AddPatientData/>}/>
                        <Route path="questions" element={<QuestionEncounter/>}/>
                    </Route>
                    {/* test pages */}
                    {/* <Route path="test_chart" element={<RecordChart test={"testing"}/>}></Route> */}
                    {/* <Route path="debugging" element={<AddDrugRecord/>}/> */}
                    {/* <Route path="addrecord" element={<AddExamineRecord/>}/>  */}
                    {/* <Route path="test" element={<ListAllDrug></ListAllDrug>}></Route> */}
                    {/* <Route path="test_image" element={<AddPDF></AddPDF>}></Route> */}
                    {/* <Route path='test_get_image' element={<AddImageFromPDF></AddImageFromPDF>}></Route> */}
                </Route>
            </Routes>
            </BrowserRouter>
        </FilterContextsProvider>
    );
}

export default App;
